import p2 from 'p2';

import { PhysicsComponent } from '../physics/PhysicsComponent';
import { BaseEntity } from './BaseEntity';

export const defaultSuspensionParams = {
    bodyA: null as p2.Body | null,
    bodyB: null as p2.Body | null,
    localAnchorA: [0, 0],
    localAnchorB: [0, 0],
    localAxisA: [0, 1],
    localAxisB: [0, 0],
    disableRotationalLock: true,
    restLength: 0.5,
    stiffness: 70,
    damping: 5,
};

export type SuspensionParams = typeof defaultSuspensionParams;

export class SuspensionEntity extends BaseEntity
{
    public params!: SuspensionParams;
    public physics: PhysicsComponent;

    constructor()
    {
        super();
        this.physics = this.addComponent(PhysicsComponent);
    }

    public build(params: Partial<SuspensionParams> = {}): void
    {
        this.physics.clearParts();
        this.params = { ...defaultSuspensionParams, ...params };

        if (!this.params.bodyA || !this.params.bodyB) throw new Error('Suspension needs both bodies to work');

        const constraint = new p2.PrismaticConstraint(this.params.bodyA, this.params.bodyB, {
            localAnchorA: this.params.localAnchorA,
            localAnchorB: this.params.localAnchorB,
            localAxisA: this.params.localAxisA,
            disableRotationalLock: this.params.disableRotationalLock,
        });

        const spring = new p2.LinearSpring(this.params.bodyA, this.params.bodyB, {
            localAnchorA: this.params.localAnchorA,
            localAnchorB: this.params.localAnchorB,
            restLength: this.params.restLength,
            stiffness: this.params.stiffness,
            damping: this.params.damping,
        } as any);

        this.physics.addParts(constraint, spring);
    }
}
